import { render, staticRenderFns } from "./VCTestDataStatistc.vue?vue&type=template&id=6df371e6"
import script from "./VCTestDataStatistc.vue?vue&type=script&lang=js"
export * from "./VCTestDataStatistc.vue?vue&type=script&lang=js"
import style0 from "./VCTestDataStatistc.vue?vue&type=style&index=0&id=6df371e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports